module.exports = __webpack_public_path__ + "img/animals.9d7d3c1.jpg";